import styled from 'styled-components'
import { HERO_USECASES } from '../../../constants/useCases.constants'
import Breadcrumbs from '../breadcrumbs'
import Typography from '../typography'

export const StyledBreadcrumbs = styled(Breadcrumbs)``

export const HeroInner = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 auto;
  flex-grow: 1;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 32px 0 64px 0;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 48px 0;
  }
`

export const HeroTitle = styled(Typography)`
  margin: 0;
  text-shadow: none;
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`

export const HeroEyebrowContainer = styled.div`
  border-radius: 16px;
  margin-bottom: 8px;
  height: 30px;
  padding: 0px 16px;
  text-align: center;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.down('xs')} {
    margin-bottom: 16px;
  }
`

export const HeroEyebrow = styled(Typography)`
  color: ${({ theme }) => theme.webMktNewPalette.white};

  text-transform: uppercase;
`

export const HeroSubheadline = styled(Typography)`
  margin-top: 16px;
  color: ${({ theme }) => theme.webMktNewPalette.deepBlue[60]};

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 8px;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    margin-top: 16px;
  }
`

export const HeroOuter = styled.div<{
  $heroTheme: string
  $useCase: string
  $pageType: string
  $displayBackgroundVideo: boolean
  $heroTextHighlight: boolean
  $backgroundPosX?: string | number
  $backgroundPosY?: string | number
  $img?: string
  $mobile_img?: string
  $tablet_img?: string
  $mobile_xs_img?: boolean
}>`
  ${({
    theme,
    $heroTheme,
    $useCase,
    $pageType,
    $displayBackgroundVideo,
    $heroTextHighlight,
    $img,
    $backgroundPosX,
    $backgroundPosY,
    $mobile_img,
    $tablet_img,
    $mobile_xs_img,
  }) => {
    let themeStyles = ''
    let pageSpecificStyles = ''
    let bgImgStyle = ''
    let heroInnerPadding = ''
    let pagePadding = ''
    let textHighlightColor = ''
    let textHightlightStyles = ''
    let companyListingStyles = ''

    const isFullWidthSolutions =
      ($pageType === 'solutions' || $pageType === 'flex') &&
      $useCase === HERO_USECASES.FULL_WIDTH_HERO

    if ($heroTheme === 'dark' || $heroTheme === 'orange') {
      const pageSpecificBG =
        $pageType === 'home' ? theme.webMktNewPalette.white : theme.webMktNewPalette.deepBlue[70]

      textHighlightColor = theme.webMktNewPalette.black

      themeStyles = `
        ${HeroEyebrowContainer} {
          background: ${theme.webMktNewPalette.white};
          p {
            color: ${theme.webMktNewPalette.black};
          }
        }

        ${HeroTitle},${HeroSubheadline} {
          color: ${theme.webMktNewPalette.white};
        }

        ${
          $img
            ? `${theme.breakpoints.down('xs')} {
            background-color: ${pageSpecificBG};
          }`
            : `background-color: ${pageSpecificBG};`
        }
      `
    }

    if ($heroTheme === 'light') {
      /*
       * There is only light/dark theme for component Hero, if
       * the $useCase in minimal the bgcolor would be #f7f7f7
       */
      const bgColor =
        $useCase === 'Product Hero'
          ? theme.webMktNewPalette.deepBlue[25]
          : theme.webMktNewPalette.deepBlue[10]
      const pageSpecificBG = $pageType === 'home' ? theme.webMktNewPalette.white : bgColor
      textHighlightColor = theme.webMktNewPalette.white

      themeStyles = `
        ${HeroEyebrowContainer} {
          background: ${theme.webMktNewPalette.deepBlue[75]};

          p {
            color: ${theme.webMktNewPalette.white};
          }
        }

        ${HeroTitle} {
          color: ${theme.webMktNewPalette.black};
        }

        ${
          $img
            ? `${theme.breakpoints.down('xs')} {
            background-color: ${pageSpecificBG};
          }`
            : `background-color:  ${pageSpecificBG};`
        }
      `
    }

    if ($heroTextHighlight) {
      textHightlightStyles = `
      && {
        ${theme.breakpoints.up('xs')} {
          ${HeroTitle}, ${HeroSubheadline} {
            padding: 8px 16px;
            background: ${textHighlightColor};
          }

          ${HeroSubheadline}{
            margin-top: 8px;
          }

          .MultiBodyHeroHeader-CTAs {
            margin: 24px 0 0 16px;
          }
        }

        ${theme.breakpoints.down('xs')} {
          .MultiBodyHeroHeader-CTAs {
            width: 100%;
          }
        }
      }
    `
    } else {
      textHightlightStyles = ``
    }

    if ($pageType === 'solutions') {
      pageSpecificStyles = `
        background-repeat: no-repeat;
        background-position: center;

        ${theme.breakpoints.down('xs')} {
          background: ${theme.webMktNewPalette.background.light.default};
        }

        ${HeroInner} {
          ${theme.breakpoints.down('xs')} {
            margin-top: 278px;
          }
        }

        .Hero__Grid {
          ${theme.breakpoints.down('sm')} {
            max-width: 454px;
          }

          ${theme.breakpoints.down('xs')} {
            max-width: 100%;
          }
        }

        .MultiBodyHeroHeader-CTAs {
          .CTA {
            @media screen and (max-width: 360px) {
              width: 100%;
            }
          }
        }

        .Hero__Container {
          position: relative;
        }

        .Hero__Solutions-Dotted-Container {
          position: absolute;
          right: -360px;
          top: 0;
          height: 100%;
          width: 588px;
          background-image: radial-gradient(rgba(23, 33, 37, 0.30) 1px,transparent 0);
          background-size: 20px 20px;

          ${theme.breakpoints.down('lg')} {
            width: 364px;
            right: -160px;
          }

          ${theme.breakpoints.down('sm')} {
            width: 275px;
            right: -100px;
          }

          ${theme.breakpoints.down('xs')} {
            width: 100%;
            height: 182px;
            right: 0;
            top: 90px;
          }

          .Hero__Solutions-Img-Circle-Robot {
            height: 384px;
            width: 384px;
            position: relative;
            top: 50%;
            transform: translateY(-50%);

            ${theme.breakpoints.down('lg')} {
              height: 304px;
              width: 304px;
            }

            ${theme.breakpoints.down('sm')} {
              height: 266px;
              width: 266px;
              left: 0;
            }

            ${theme.breakpoints.down('xs')} {
              left: 50%;
              transform: translateX(-50%);
              top: -42px;
            }
          }

          .Hero__Solutions-Img-Robot {
            position: absolute;
            bottom: 0;
            left: -102px;
            height: auto;
            width: 79px;

            ${theme.breakpoints.down('sm')} {
              width: 76px;
              left: -102px;
            }

            ${theme.breakpoints.down('xs')} {
              left: 0;
            }
          }

          .Hero__Solutions-Img-Circle {
            border-radius: 192px;
            overflow: hidden;
            height: 100%;
            width: 100%;
            position: relative;
            left: -102px;

            ${theme.breakpoints.down('xs')} {
              left: 0;
            }
          }
        }
      `
    } else if ($pageType === 'home') {
      pageSpecificStyles = `
        ${textHightlightStyles}
        min-height: 600px;

        ${theme.breakpoints.down('md')} {
          min-height: 480px;
        }

        ${theme.breakpoints.down('sm')} {
          min-height: 400px;
          padding-bottom: 0;
        }

        ${theme.breakpoints.down('xs')} {
          background-size: auto 300px;
          padding-bottom: 48px;
        }

        @media(max-width: 360px) {
          background-image: url(${$mobile_xs_img});
        }

        .Hero__Grid {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        ${HeroTitle} {
        
          @media(max-width: 500px) {
            .LineBreak {
              &:not(:nth-child(1)) {
                display: inline;
              }
            }
          }
        }

        ${HeroTitle}, ${HeroSubheadline}{
          ${theme.breakpoints.down('xs')} {
            color: ${theme.webMktPalette.text.primaryBlack};
          }
        }

        .Hero__Container {
          ${theme.breakpoints.down('sm')} {
            max-width: 100%;
          }
        }

        ${HeroInner} {
          justify-content: flex-start;
          ${theme.breakpoints.down('sm')} {
            margin-top: 324px;
          }
        }

        .LineBreak {
          ${theme.breakpoints.down('xs')} {
            display: block;
          }
        }
      `
    } else if (
      $pageType === 'resourceListing' ||
      $pageType === 'events' ||
      $pageType === 'flex' ||
      $pageType === 'rawHTML'
    ) {
      const mobileBackgroundStylesEvents = `
        
      `
      const mobileBackgroundStyles =
        $heroTheme === 'light' && $pageType !== 'events'
          ? `background: ${theme.webMktNewPalette.deepBlue[10]};
        background-image: none;`
          : `background-size: auto 270px;`

      let backgroundColor = $displayBackgroundVideo
        ? `background: ${theme.webMktNewPalette.background.dark.default};`
        : ``

      pageSpecificStyles = `
        ${$pageType === 'events' ? textHightlightStyles : ''}
        min-height: 344px;
        ${backgroundColor}

        ${theme.breakpoints.down('md')} {
          min-height: 352px;
        }

        ${theme.breakpoints.down('xs')} {
          min-height: 0;
          ${mobileBackgroundStyles}
        }

        ${HeroInner} {
          justify-content: center;
          ${theme.breakpoints.down('xs')} {
            ${$pageType === 'events' ? `margin-top:230px;` : 'margin-top:0px;'}            
            padding-top: 32px;
          }
        }

        .MultiBodyHeroHeader-CTAs {
          display: none;
        }

        .Hero__Grid {
        
          ${theme.breakpoints.down('xs')} {
            max-width: 100%;
          }
          .hero__banner--logoimg{
            padding-bottom:16px;
            height:64px;
            }
            .Lead,.Lead > p, .hero__content p, .hero__content p > p {
          
            margin-top:8px;
            color: ${
              $heroTheme === 'light'
                ? theme.webMktNewPalette.deepBlue[60]
                : theme.webMktNewPalette.white
            };
         
            }
        }

        .Hero__Container {
          position: relative;

          ${HeroInner}, ${StyledBreadcrumbs} {
            z-index: 6;
          }
        }

        .Hero__Gradient, .Hero__Video {
          position: absolute;
          height: 100%;
          max-width: calc(100% + (1920px - 100%) / 2 - 24px);
          width: calc(100% + (100vw - 100%) / 2);
          width: calc(100% + (100vw - 100%) / 2);
          top: 0;
          left: 24px;

          ${theme.breakpoints.down('xs')} {
            display: none;
          }
        }

        .Hero__Gradient {
          background: linear-gradient(-90deg, rgba(23, 33, 37, 0) 50%, rgb(23, 33, 37) 100%);
          z-index: 5;
        }

        .Hero__Video {
          z-index: 4;
          object-fit: cover;
        }
      `
    } else if ($useCase === 'Centered text with dots') {
      themeStyles += `
        ${HeroInner} {
          padding: 60px 0;
        }

        ${HeroEyebrowContainer} {
          background: none;
          width: 100%;

          p {
            color: ${theme.webMktNewPalette.deepBlue[55]};
          }
        }

        .MuiGrid-root {
          justify-content: center;
        }

        .MuiGrid-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
      `
    } else {
      pageSpecificStyles = `
        ${
          $useCase !== 'Minimal' &&
          `
          min-height: 500px;

          ${theme.breakpoints.down('md')} {
            min-height: 364px;
          }

          ${theme.breakpoints.down('xs')} {
            background-size: auto 270px;
            .MultiBodyHeroHeader-CTAs {
              width: 100%;
              .CTA {
                width: 100%;
              }
            }
          }

          ${HeroInner} {
            justify-content: center;

            ${theme.breakpoints.down('xs')} {
              margin-top: 230px;
            }
          }
          `
        }
        ${
          $useCase === HERO_USECASES.FULL_WIDTH_HERO &&
          `
            ${HeroEyebrowContainer} {
              background: none;
              padding: 0px;    
              p {
                color: ${
                  $heroTheme === 'light'
                    ? theme.webMktNewPalette.black
                    : theme.webMktNewPalette.white
                };
              }
            }
            ${theme.breakpoints.down('xs')} {
              background-size: cover;
            }
            ${HeroInner} {  
              ${theme.breakpoints.down('xs')} {
                margin-top: 0;
              }
            }
          `
        }        
      `
    }

    if ($pageType === 'product') {
      pageSpecificStyles += `
        ${HeroEyebrowContainer} {
          background: none;
          padding: 0;

          p {
            color: ${
              $heroTheme === 'light' ? theme.webMktNewPalette.black : theme.webMktNewPalette.white
            };
          }
        }
      `
    }

    if ($pageType === 'formFlex') {
      pageSpecificStyles += `
          min-height: 290px;
          min-width: 100%;

        ${theme.breakpoints.down('md')} {
          min-height: 290px;
        }
      `
    }

    if ($img && $useCase !== 'Centered text with dots') {
      bgImgStyle = `
        background-image: url(${$img});
        background-position: ${$backgroundPosX}% ${$backgroundPosY}%;
        background-size: cover;

        ${theme.breakpoints.down('md')} {
          background-image: url(${$tablet_img});
          min-height: 364px;
        }

        ${theme.breakpoints.down('xs')} {
          background-image: url(${$mobile_img});
          background-repeat: no-repeat;
          background-position-y: top;
          background-position-x: 80%;
        }

        ${HeroInner} {
          ${theme.breakpoints.down('xs')} {
            margin-top: 230px;
          }
        }
      `
      if ($useCase === HERO_USECASES.FULL_WIDTH_HERO) {
        bgImgStyle = `
          background-image: url(${$img});
          background-position: ${$backgroundPosX}% ${$backgroundPosY}%;
          background-size: cover;

          ${theme.breakpoints.down('xs')} {
            background-image: ${$pageType === 'solutions' || $pageType === 'flex' ? 'none' : ''};
          }
        `

        pageSpecificStyles = `
          ${HeroSubheadline}{
          
          }

          ${HeroEyebrowContainer}{
            background: transparent;
            padding: 0;

            ${HeroEyebrow}{
             
              color: ${
                $heroTheme === 'light' ? theme.webMktNewPalette.black : theme.webMktNewPalette.white
              };
            }
          }
        `
      }
    } else if ($useCase === 'Centered text with dots') {
      bgImgStyle = `
        background-image: url(${$img});
        background-position: 50% 0;
        background-size: cover;
      `
    } else {
      bgImgStyle = ``
    }

    let minimal = `
      padding: 56px 0 48px;

      ${theme.breakpoints.down('sm')} {
        padding: 32px 0 36px;
      }

      ${theme.breakpoints.down('xs')} {
        padding: 27px 0 32px;
      }
    `

    let product = `
      padding: 56px 0 96px 0;

      ${theme.breakpoints.down('md')} {
        padding: 32px 0 64px 0;
      }

      ${theme.breakpoints.down('xs')} {
        padding: 48px 0;
      }
    `

    let hompage = `
      padding: 128px 0 96px 0;

      ${theme.breakpoints.down('md')} {
        padding: 96px 0 164px 0;
      }

      ${theme.breakpoints.down('sm')} {
        padding: 96px 0 120px 0;
      }

      ${theme.breakpoints.down('xs')} {
        padding: 0;
      }
    `

    let dottedHeroPadding = `
      padding-bottom: 64px;
      min-height: 360px;
    `

    if ($useCase === 'Minimal') {
      pagePadding = minimal
    } else if ($pageType === 'home') {
      pagePadding = hompage
    } else if ($useCase === 'Centered text with dots') {
      pagePadding = dottedHeroPadding
    } else {
      pagePadding = product
    }

    heroInnerPadding = `
      ${HeroInner} {
        ${pagePadding}
      }

      ${StyledBreadcrumbs} {
        padding-top: 24px;
        width: 100%;
        min-height: 32px;

        ${theme.breakpoints.down('xs')} {
          padding-top: 16px;
        }
      }
    `
    if ($pageType === 'companyListing') {
      companyListingStyles = `
        min-height: 336px;

        ${theme.breakpoints.down('md')} {
          min-height: 312px;
        }

        ${theme.breakpoints.down('sm')} {
          min-height: 224px;
        }
      `
    }

    return `
      ${themeStyles}
      ${bgImgStyle}
      ${heroInnerPadding}
      ${companyListingStyles}
      ${pageSpecificStyles}

      ${
        $pageType === 'home'
          ? `
      && {
        .Hero__Secondary-CTA {
          ${theme.breakpoints.down('xs')} {
            background: none;
            color: ${theme.webMktNewPalette.black};
            border: 2px solid ${theme.webMktNewPalette.black};

            .CTA__Arrow-Container {
              svg {
                #ArrowPath {
                  fill: ${theme.webMktNewPalette.black};
                }
              }
            }

            &:hover {
              background: ${theme.webMktNewPalette.alphaBlack[20]};
              color: ${theme.webMktNewPalette.black};
              border: 2px solid ${theme.webMktNewPalette.black};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: ${theme.webMktNewPalette.black};
                  }
                }
              }
            }

            &:active {
              background: rgb(0 0 0 / .2);
              color: #9D9D9D;
              border: 2px solid ${theme.webMktNewPalette.black};

              .CTA__Arrow-Container {
                svg {
                  #ArrowPath {
                    fill: #9D9D9D;
                  }
                }
              }
            }
          }
        }
      }`
          : ``
      }

      max-width: 1920px;
      margin: 0 auto;
      display: flex;

      .CTA:nth-child(2) {
        margin-left: 24px;
      }

      ${HeroTitle}, ${HeroSubheadline}, ${HeroEyebrowContainer} {
        max-width: 972px;
      }

      .MultiBodyHeroHeader-CTAs {
        margin-top: 32px;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        ${$pageType === 'thankYou' ? `justify-content: center;` : ''}

        ${theme.breakpoints.down('xs')} {
          flex-direction: column;

          .CTA {
            display: flex;
            justify-content: ${$pageType === 'thankYou' ? 'center' : 'space-between'};
            width: 100%;
          }

          .CTA:nth-child(2) {
            margin-left: 0;
            margin-top: 16px;
          }
        }
          .CTA{white-space:nowrap}
      }

      &.Hero__FullWidth{
        min-height: auto;
        overflow: hidden;

        ${theme.breakpoints.down('sm')} {
          min-height: ${$pageType === 'solutions' || $pageType === 'flex' ? 'auto' : '680px'};
        }
        
        ${theme.breakpoints.down('xs')} {
          min-height: auto;
        }

        .Hero__Container {
          color:#090900;
          &.light-gradient{
             background: linear-gradient(to right, rgb(255, 255, 255), rgba(255, 255, 255, 0));
          }
          &.dark-gradient{
            background: linear-gradient(to right, rgba(23, 33, 37, 0.9), rgba(23, 33, 37, 0));
          }
          ${HeroTitle} {
            color: ${
              $heroTheme === 'light' ? theme.webMktNewPalette.black : theme.webMktNewPalette.white
            };
          }
         ${HeroSubheadline}, ${HeroEyebrow} {
            color: ${
              $heroTheme === 'light'
                ? theme.webMktNewPalette.deepBlue[60]
                : theme.webMktNewPalette.white
            };
          }
        }

        .heroInner {
          display: block;
          padding-top: 40px;
          padding-bottom: 84px;

          .Hero__Solution-Mobile{
            margin: -82px -24px 24px;
            display: none;
            max-height: 480px;
            overflow: hidden;

            ${theme.breakpoints.down('xs')} {
              display: block;

              img {
                min-height: 200px;
                object-fit: cover;
                object-position: center center;
                width: 100%;
              }
            }
          }
          .Hero__FullWidth-CBlock {
            height: 100%;
            ${theme.breakpoints.down('xs')} {
              display: block;
            }

            .Hero__Grid {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              ${theme.breakpoints.down('sm')} {   
                ${isFullWidthSolutions ? `justify-content: flex-start;` : ''}
              }

              .Hero__Secondary-CTA{
                padding: 12px 24px 12px 16px;

                &.text-light{
                  color: ${theme.webMktNewPalette.white}
                }
                &.text-dark{
                  color: ${theme.webMktNewPalette.black}
                }
              }
            }

            .Hero__VideoPlayer{
              max-width: 640px;
              margin: 0 auto;                
            }
            .VideoPlayer__Image-File {
              object-fit: cover;
              max-width: 640px;
              max-height: 360px;
            }
          }          
        }

      }

      .Hero__Container {
        width: 100%;
        ${$useCase === HERO_USECASES.FULL_WIDTH_HERO ? `max-width: 100%;` : ''}        
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;

        ${theme.breakpoints.down('xs')} {
          max-width: 736px;
        }
      }
    `
  }}
`

export const SolutionsHeroCircle = styled.div<{ $backround: string }>`
  ${({ $backround, theme }: any) => {
    return `
      background-image: url('${$backround}');
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position-x: 50%;
      bottom: 0;
      ${theme.breakpoints.down('lg')} {
        background-position-x: 50%;
      }
      ${theme.breakpoints.down('sm')} {
        background-position-x: 50%;
      }
    `
  }}
`
